import { BACKEND_URL, get } from '../../../../util/api'
import * as type from './type'
import * as names from '../const'

const ADD_FILE_ENDPOINT_LIST = {
    [names.FILE_TYPE_IMAGE]: '',
    [names.FILE_TYPE_SCAN_FILE]: '/api/customer/add-scan-file?customerId=',
    [names.FILE_TYPE_IMPLANT_SCAN_FILE]: '/api/customer/add-implant-scan-file?customerId=',
    [names.FILE_TYPE_X_RAY]: '/api/customer/add-x-ray-file?customerId=',
    [names.FILE_TYPE_TREATMENT_PLAN]: '/api/customer/add-treatment-plan-file?customerId=',
    [names.FILE_TYPE_TREATMENT_PLAN_EXTERNAL]: '/api/customer/add-treatment-plan-external-file?customerId=',
    [names.FILE_TYPE_PRODUCTION]: '/api/customer/add-production-file?customerId=',
    [names.FILE_TYPE_IMPLANT_TREATMENT_PLAN]: '/api/customer/add-implant-treatment-plan-file?customerId=',
    [names.FILE_TYPE_OTHER_FILES]: '/api/customer/add-other-file?customerId=',
}

const getEndpoint = (fileType, customerId) => {
    return BACKEND_URL + ADD_FILE_ENDPOINT_LIST[fileType] + customerId || ''
}

export const uploadCustomerFileRequest = (fileType) => ({
    type: type.UPLOAD_CUSTOMER_FILE_REQUEST,
    payload: {
        fileType,
    },
})

export const uploadCustomerFileSuccess = (fileType, file) => ({
    type: type.UPLOAD_CUSTOMER_FILE_SUCCESS,
    payload: {
        fileType,
        file,
    },
})

export const uploadCustomerFileError = (fileType, error) => ({
    type: type.UPLOAD_CUSTOMER_FILE_ERROR,
    payload: {
        fileType,
        error,
    },
})

export const uploadCustomerFile = (fileList, customerId, fileType, onUploadSuccess) => (dispatch, getState) => {
    dispatch(uploadCustomerFileRequest(fileType))

    for (let index = 0; index < fileList.length; index++) {
        const data = new FormData()
        data.append('file', fileList[index])

        const endpoint = getEndpoint(fileType, customerId)

        fetch(endpoint, {
            method: 'post',
            body: data,
            headers: {
                Accept: 'application/json',
            },
            credentials: 'include',
        }).then(response => {
            return response.json()
        }).then(file => {
            dispatch(uploadCustomerFileSuccess(fileType, file))
            onUploadSuccess(fileType, file)
        }).catch(error => {
            dispatch(uploadCustomerFileError(fileType, error))
        })
    }
}


export const setDeleteFlagRequest = (fileType, fileId) => ({
    type: type.SET_DELETE_FLAG_REQUEST,
    payload: {
        fileType,
        fileId,
    },
})

export const setDeleteFlagSuccess = (fileType, fileId) => ({
    type: type.SET_DELETE_FLAG_SUCCESS,
    payload: {
        fileType,
        fileId,
    },
})

export const setDeleteFlagError = (fileType, error) => ({
    type: type.SET_DELETE_FLAG_ERROR,
    payload: {
        fileType,
        error,
    },
})

export const setDeleteFlag = (fileType, fileId, onDeleteFlagSuccess) => (dispatch, getState) => {
    dispatch(setDeleteFlagRequest(fileType, fileId))

    get('/api/file-system/set-delete-flag?fileId=' + fileId)
        .then(() => {
            dispatch(setDeleteFlagSuccess(fileType, fileId))
            onDeleteFlagSuccess(fileType, fileId)
        })
        .catch((error) => {
            dispatch(setDeleteFlagError(fileType, error))
        })
}


export const triggerVisualizationRequest = () => ({
    type: type.TRIGGER_VISUALIZATION_REQUEST,
})

export const triggerVisualizationSuccess = (fileType, fileId) => ({
    type: type.TRIGGER_VISUALIZATION_SUCCESS,
})

export const triggerVisualizationError = (fileType, error) => ({
    type: type.TRIGGER_VISUALIZATION_ERROR,
})

export const triggerVisualization = (customerId) => (dispatch, getState) => {
    dispatch(triggerVisualizationRequest())

    get('/api/treatment/visualization/trigger?customerId=' + customerId + '&processInstanceId=' + customerId)
        .then(() => {
            dispatch(triggerVisualizationSuccess())
        })
        .catch((error) => {
            dispatch(triggerVisualizationError(error))
        })
}




// WEBPACK FOOTER //
// ./src/modules/customer/state/file-upload/action.js